import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components/macro";
import { CssBaseline } from "@mui/material";
import PerfectScrollBar from "react-perfect-scrollbar";

import GlobalStyle from "../components/GlobalStyle";
import Carousel from "./auth layout components/Carousel";

const Root = styled.div`
  display: flex;
  height: 100vh;

  > div {
    width: 50%;
    flex: 1;
  }
`;

const ScrollBar = styled(PerfectScrollBar)`
  margin: 4px;
  height: calc(100% - 8px) !important;
  display: flex;

  > * {
    flex: 1;
  }
`;

export default function AuthLayout() {
  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />

      <Carousel />

      <ScrollBar>
        <Outlet />
      </ScrollBar>
    </Root>
  );
}
